export const TEST_SHOP_BASE_API_URL = "https://api-sandbox.beta.cloverbaylabs.com";
export const CLOVERBAY_LABS_BASE_API_URL = "https://api.beta.cloverbaylabs.com";
// export const TEST_SHOP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
// export const CLOVERBAY_LABS_BASE_API_URL = process.env.CLOVERBAY_LABS_BASE_API_URL;
